var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGridChange4Col = function SvgIconGridChange4Col(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.666 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h3.128a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm3.103 1.667H2.692v11.666h3.077zM10.36 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h3.128a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm3.102 1.667h-3.077v11.666h3.077z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.205 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h3.128a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm3.103 1.667H14.23v11.666h3.077zM6.514 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h3.128a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm3.102 1.667H6.54v11.666h3.077z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGridChange4Col;